import React from "react";
import "./footer.scss";

const Footer = () => {
	const  date = new Date().getFullYear();
	
	return (
		<footer className='footer'>
			<p> © {date}  plutos ONE, India. All rights reserved. </p>
		</footer>
	);
};

export default Footer;
